module.exports = __webpack_public_path__ + "static/media/sessions-icon.c484c28e.svg";